/** The browser's Gamepad API as the input core's `GamepadSource`. */
import type { GamepadLike, GamepadSource } from '@hf/client-core/input/gamepad';

export const browserGamepadSource = (): GamepadSource | null => {
  if (typeof navigator === 'undefined' || typeof navigator.getGamepads !== 'function') return null;
  return { getGamepads: () => navigator.getGamepads() as unknown as ArrayLike<GamepadLike | null> };
};
